import type { AdminRole } from '@/lib/api-admin';

/**
 * 글로벌 주문서 추가정보(통관 필드) 관리 RBAC. (be-order 계약 가정 — order-service
 * `@PreAuthorize` 가 SUPER_ADMIN / OPS_ADMIN 만 허용한다고 가정.)
 * orderPolicy / shippingFee 와 동일한 운영 권한 게이트. read·write 동일 게이트
 * (설정 페이지 전체가 운영 권한). 계약 확정 후 정합.
 */
export const ORDER_FORM_FIELD_ROLES: ReadonlyArray<AdminRole> = [
  'SUPER_ADMIN',
  'OPS_ADMIN',
];
